<div class="work-ui-button-group">
  <ul #buttonGroup [class.hide]="buttonGroupOverflows"
      class="work-button-group"
      role="tablist">
    @for (button of buttonGroupOptions; track button; let i = $index) {
      <li role="presentation">
        <button (click)="setActiveButton(button.value)"
                [attr.aria-selected]="button.value === activeButton"
                [attr.tabindex]="button.value === activeButton ? 0 : -1"
                [class.active]="button.value === activeButton"
                [disabled]="allButtonsDisabled"
                [id]="'button-' + button.value"
                role="tab">
          {{ button.label | translate }}
        </button>
      </li>
    }
  </ul>
  @if (buttonGroupOverflows) {
    <work-ui-select (valueChanged)="setActiveButton($event)"
                    [class]="mobileSelectAlignment"
                    [disableHint]="true"
                    [disabled]="allButtonsDisabled"
                    [hideHint]="true"
                    [maxWidth]="300"
                    [name]="'buttonOptionsMobile'"
                    [options]="selectOptions"
                    [value]="activeButton"
                    class="work-ui-button-group__select display-block">
    </work-ui-select>
  }
</div>
